type THeaderState = "top" | "scrolled";

export interface IHeaderScrollState {
  headerState: THeaderState;
  bottomNavVisible: boolean;
}

/** The header compacts past this scroll offset… */
export const HEADER_COMPACT_AFTER = 80;
/** …and expands again only above this one, so it can't flicker around one line. */
export const HEADER_EXPAND_BEFORE = 20;
/** The mobile bottom nav hides on a downward scroll past this offset. */
export const BOTTOM_NAV_HIDE_AFTER = 100;

export const headerScrollService = {
  /**
   * Header and bottom-nav state after a scroll from `lastY` to `y`. Returns `prev` itself
   * when nothing changed, so a React state update with it bails out without a render.
   */
  next(prev: IHeaderScrollState, lastY: number, y: number): IHeaderScrollState {
    let headerState = prev.headerState;
    if (headerState === "top" && y > HEADER_COMPACT_AFTER) {
      headerState = "scrolled";
    } else if (headerState === "scrolled" && y < HEADER_EXPAND_BEFORE) {
      headerState = "top";
    }

    let bottomNavVisible = prev.bottomNavVisible;
    if (y > lastY && y > BOTTOM_NAV_HIDE_AFTER) {
      bottomNavVisible = false;
    } else if (y < lastY || y <= BOTTOM_NAV_HIDE_AFTER) {
      bottomNavVisible = true;
    }

    return headerState === prev.headerState &&
      bottomNavVisible === prev.bottomNavVisible
      ? prev
      : { headerState, bottomNavVisible };
  },
};
